import axios from "../../axios";

const changePassword = async function (accessToken,userId,password,rePassword) {
    try {
        const response = await axios.post('/partner/changePassword', {
            userId,
            password,
            rePassword
        }, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default changePassword;
